import {FC, PropsWithChildren} from "react";
import {Exist, Preloader} from "components";
import {TableLoadMoreButton, TableWrapper, TablePreloaderWrapper} from "./common";

interface ITable {
	isLoading: boolean;
	nextPage: boolean;
	loadMoreHandler: () => void;
	buttonText: string;
}

export const Table: FC<PropsWithChildren<ITable>> = ({
	isLoading,
	nextPage,
	loadMoreHandler,
	buttonText,
	children,
}) => {
	return (
		<TableWrapper>
			{children}

			{isLoading ? (
				<TablePreloaderWrapper>
					<Preloader />
				</TablePreloaderWrapper>
			) : (
				<Exist when={nextPage}>
					<TableLoadMoreButton onClick={loadMoreHandler} disabled={isLoading}>
						{buttonText}
					</TableLoadMoreButton>
				</Exist>
			)}
		</TableWrapper>
	);
};
